import PropTypes from 'prop-types';
import { Flex, Box, Select } from 'theme-ui';
import SpinnerBar from '~/components/Spinner/loader';

const QuantitySelector = ({ handleChange, lineItemId, options = [], forwardSx, defaultValue, ...props }) => {
  const onChange = (event) => {
    const quantity = event.target.value;
    if (handleChange) handleChange(quantity);
  };

  return (
    <Flex
      sx={{
        flexDirection: 'column',
        justifyContent: 'center',
        position: 'relative',
        width: '6.6rem',
        ...forwardSx,
      }}
    >
      {props.isLoading && (
        <Flex sx={{ position: 'relative', top: '10px' }}>
          <SpinnerBar forwardSx={{ width: '70% !important' }} />
        </Flex>
      )}
      <Box sx={{ ml: '-1rem', px: '1rem', position: 'relative' }}>
        {!props.isLoading && (
          <Select
            sx={{
              variant: 'text.h5',
              fontSize: '1.2rem !important',
              border: 0,
              padding: '0px 8px',
              margin: '0 -8px',
              lineHeight: '1.2rem',
              borderRadius: '0% !important',
              width: 'calc(5.6rem + 1.6rem)',
              '& + svg': {
                position: 'absolute',
                right: 0,
                height: '16px',
              },
            }}
            name="quantity"
            onChange={onChange}
            id={`quantity-selector-${lineItemId}`}
            {...props}
          >
            {options.map(({ name, value }) => (
              <option key={value} value={value}>
                {name || value}
              </option>
            ))}
          </Select>
        )}
      </Box>
    </Flex>
  );
};

QuantitySelector.propTypes = {
  handleChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    })
  ),
};

export default QuantitySelector;
